import { df, getYear, momentDate } from 'util/dateTime';

export const DEFAULT_PARSE_FORMAT = 'MM/DD/YYYY';
export const UNIFORM_WIDTH = 128;

export const isValidDate = date => {
  if (!date) {
    return true;
  }

  const year = getYear(date, df('date') || DEFAULT_PARSE_FORMAT);

  return year >= 1900 && year <= 2100;
};

export const toParsableDate = date => {
  if (!date) return;
  if (df('date') !== DEFAULT_PARSE_FORMAT) {
    const UKDateFormat = momentDate(date, df('date'));
    return UKDateFormat.format(DEFAULT_PARSE_FORMAT);
  }
  return date;
};
